import { render, staticRenderFns } from "./TableMappingFields.vue?vue&type=template&id=2135140e"
import script from "./TableMappingFields.vue?vue&type=script&lang=js"
export * from "./TableMappingFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports